import React, { useContext } from 'react';

export const ForceRerenderContext = React.createContext<{
  forceRerender: () => void;
}>({
  forceRerender: () => undefined
});

export const useForceRerender = () => useContext(ForceRerenderContext);
